import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-md-10" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-md-10 fw-bold text-danger" }
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = { class: "col-md-10 fw-bold" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = ["disabled"]

import { onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    exibir: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportarRetorno',
  props: {
    exibir: { type: Boolean }
  },
  emits: ["importou","erro", "fechou"],
  setup(__props: any, { emit: __emit }) {


//vue
var props = __props;
var emit = __emit;
const router = useRouter();

var controle = reactive({ 
    
    janRetorno: false,
    param: {
        paramBoletoId: 1,
        arquivo: null as File | null,
    } as service.ImportarRetornoDTO & { arquivo: File | null },

    loading: false,
    status: "",
    erro: ""
});

onMounted(() => {
    console.log("onMounted");

})

watch(() => props.exibir, async (novoValor) => {

    controle.janRetorno = novoValor;

    if (controle.janRetorno == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janRetorno");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

})

function onFileChange(event: Event) {
    const target = event.target as HTMLInputElement;

    console.log("target.files", target.files);

    if (target.files && target.files.length > 0) {
        controle.param.arquivo = target.files[0];
    } else {
        controle.param.arquivo = null;
    }
}

async function importar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Importando retorno ...`;

    await service.importarRetorno(controle.param)
    .then(r=> {
        controle.status =  `Importado com sucesso`;
        emit("importou");
                
        setTimeout(() => {
            controle.loading = false;
            fechar();
            // Redirecionar para a página de itens do retorno
            router.push({ name: "boletosRetornosItens", params: { id: r.retornoId } });
        }, 4000);

        controle.janRetorno = false;
    })  
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}


function fechar() {
    controle.janRetorno = false;
    emit("fechou");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(MsgBox, {
      id: 'janRetorno',
      titulo: 'Importar retorno',
      exibir: _unref(controle).janRetorno,
      onOnFechou: _cache[5] || (_cache[5] = ($event: any) => (_unref(controle).janRetorno = false))
    }, {
      default: _withCtx(() => [
        _createVNode(TrataTecla, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Arquivo")
              ], -1)),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("input", {
                  type: "file",
                  class: "form-control form-control-sm",
                  onChange: onFileChange,
                  ref: "arquivo"
                }, null, 544)
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-2" }, " Convênio ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(DropdownParamBoleto, {
                  modelValue: _unref(controle).param.paramBoletoId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).param.paramBoletoId) = $event)),
                  id: "inputFocus  "
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Usuário")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).param.nomeUsuario) = $event)),
                  id: "nomeUsuario",
                  ref: "nomeUsuario"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.nomeUsuario]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-2" }, [
                _createElementVNode("label", null, "Senha")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).param.senha) = $event)),
                  ref: "senha"
                }, null, 512), [
                  [_vModelText, _unref(controle).param.senha]
                ])
              ])
            ]),
            (_unref(controle).erro != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(controle).erro), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).status != '' && _unref(controle).erro == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-cog fa-spin" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(controle).status), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("hr")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (importar())),
                  disabled: _unref(controle).loading
                }, "Importar", 8, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("a", {
                  class: "btn btn-secondary btn-sm float-end",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (fechar())),
                  disabled: _unref(controle).loading
                }, "Fechar", 8, _hoisted_17)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})